export const IFRAME_EVENT_TYPE = {
  slots_city_close_iframe: 'slots_city_close_iframe',
}
export const APP_CONFIG = {
  CLOSE_NOTIFICATION_MS: 7000,
}
